import {h, Component} from 'preact'
import Spinner from "./Spinner";
import util from '../util';

export default function AppCanvas({
                                    isDesignLoading,
                                    isVersionPreview,
                                    isTakeout,
                                    isFoldedMenu,
                                    isTableTent,
                                    isSticker,
                                    isLabel,
                                    isSandwichBoard,
                                    isMobileVersion,
                                    isDigitalMenuBoard,
                                    pages,
                                    hasVideo,
                                    isLogo,
                                    isViewAllPages,
                                    hasViewOnlyPermission
                                  }) {

  return (
    <div id="canvas">
      {isDesignLoading && <Spinner/>}

      {hasViewOnlyPermission && <div className={"view-only-blocker-canvas"}></div>}
      <div id="preview-block" className={'preview-block' + (isVersionPreview ? '' : ' hidden')}/>
      <style id="canvas-styles"/>

      {isMobileVersion && !isTakeout && !isFoldedMenu && !isTableTent && !isSticker && !isLabel && !isSandwichBoard && !isVersionPreview && !isViewAllPages}

      <div id="pages" className={`pages ${isViewAllPages ? 'view-all-pages' : ''}`}/>
      <div id="preview-pages" className="pages" style="display: none"/>

      {!hasViewOnlyPermission &&
        <div className={`add-page-wrap 
        ${((isTakeout || isFoldedMenu || isTableTent || isSandwichBoard) && pages > 1) ||
        ((hasVideo && ((util.isPixelDesign() && !isLogo) || isDigitalMenuBoard)) && pages > 2) ||
        isSticker || isLabel || isVersionPreview || isMobileVersion ? 'hidden' : ''}`}>
          <a id="add-page" className={'btn tertiary hint--top'}>Add Page</a>
        </div>}
    </div>
  )
}
